import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import firebaseConfig from './firebaseConfig'
const firebaseApp = firebase.initializeApp(firebaseConfig)
const firestore = firebaseApp.firestore()
firestore.enablePersistence()
export default firestore


// WEBPACK FOOTER //
// ./src/components/firebaseInit.js